import LikeHeartIcon from '../../src/legacy/LikeHeartIcon.tsx';
export default LikeHeartIcon;
